var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.36571 0 0 5.1645 0 11.55C0 20.2125 12 33 12 33C12 33 24 20.2125 24 11.55C24 5.1645 18.6343 0 12 0ZM12 15.675C10.8634 15.675 9.77327 15.2404 8.96954 14.4668C8.16582 13.6932 7.71429 12.644 7.71429 11.55C7.71429 10.456 8.16582 9.40677 8.96954 8.63318C9.77327 7.8596 10.8634 7.425 12 7.425C13.1366 7.425 14.2267 7.8596 15.0305 8.63318C15.8342 9.40677 16.2857 10.456 16.2857 11.55C16.2857 12.644 15.8342 13.6932 15.0305 14.4668C14.2267 15.2404 13.1366 15.675 12 15.675Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.694060de75f04b9070dc356a8fdc67f2.svg";
export { ForwardRef as ReactComponent };